import RolesSelect from './RolesSelect';

export default RolesSelect;
